export default {
  main: {},
  hfive: {
    path: '/',
    component: require('VIEW/frame').default,
    indexRoute: {
      getComponent(nextState, cb) {
        require.ensure(
          [],
          (require) => {
            cb(null, require('VIEW/common/base').default);
          },
          'h5LoginView',
        );
      },
    },
    childRoutes: [
      ...require('./agreement/agreementRedux').default, //中文
      ...require('./agreement/en/agreementRedux').default, //英文
      ...require('./agreement/pt/agreementRedux').default, //葡文
      require('./h5/demoRoute').default,
      require('./common/demo').default,
      require('./anouncement/template').default,
      require('./app/activeGuide/mobileList').default,
      require('./app/activeGuide/activeDetail').default,
      require('./app/certification/enterpriseCert').default,
      require('./app/certification/merchantList').default, //商户列表
      require('./common/result').default,
      require('./app/merchantQr/principleInstru').default,
      require('./app/download/index').default,
      require('./app/userManual/manual').default,//用户手册
      require('./app/userManual/video').default,//用户手册视频
      require('./app/recharge/rule').default,//充值规则
      require('./app/openPaypay/index').default,//唤醒app页面
      require('./app/merchantService/staffList').default,//员工列表
      require('./app/merchantService/addStaff').default,//员工列表
      require('./app/merchantService/staffDetail').default,//员工详情
      require('./app/merchantService/collectionAnalysis').default,//收入分析
      require('./app/merchantService/staffResult').default,//店员扫邀请码
      require('./app/merchantService/helpDoc').default,//帮助文档
      require('./app/personalCert/idUpload').default,//个人认证
      require('./app/personalCert/confirm').default,//个人认证
      require('./app/cashback/list').default,//返现列表
      require('./app/cashback/detail').default,//返现详情
      require('./app/cashback/anouncement').default,//返现公告
      require('./app/cashback/reductionList').default,//立减列表
      require('./app/cashback/reductionDetail').default,//立减详情
      require('./app/share/shareStore').default,
      require('./app/share/shareGroup').default,
      require('./app/share/shareCoupon').default,
      require('./app/share/shareError').default,
      require('./app/lucky/luckyApp').default,
      require('./app/lucky/luckyList').default,


      //活动
      require('./common/deciarationOfWitness').default,
      require('./common/agentAgreements').default,
      require('./activity/tleva').default,
      require('./404Redux').default,
      
    ],
  },
};

/*
  当前路由树如下
  ├ /
  |
  ├ /msg
  ├ /msg/add
  ├ /msg/detail/:msgId
  ├ /msg/modify/:msgId
  |
  ├ /todo
  |
  ├ /redirect
*/



// WEBPACK FOOTER //
// ./src/route/routerDom.js